import permissions from "../permissions";
import Organization from "../../api/model/organizations/Organization";
import OrganizationProfiles from "../../model/OrganizationProfiles";
import BarrelUser from "../../model/BarrelUser";

export function getTransferableOrganizations(
    organizations: Organization[],
    organizationProfiles: OrganizationProfiles,
    selectedOrganizationId: string
): Organization[] {
    return organizations.filter(({ _id, status }) => {
        const profile = organizationProfiles[_id];
        return (
            profile &&
            permissions.canReceiveOwnership(profile) &&
            status === "active" &&
            selectedOrganizationId !== _id
        );
    });
}

export function getTransferableUsers(
    users: BarrelUser[],
    currentUserId: string,
    selectedOrganizationId: string
): BarrelUser[] {
    return users.filter(
        ({ user: { _id, status } }) =>
            status !== "invited" &&
            !(_id === currentUserId && selectedOrganizationId === "user")
    );
}
